import { Injectable } from '@angular/core';
import { HttpInterceptor, HttpRequest, HttpHandler, HttpEvent } from '@angular/common/http';
import { Observable, from } from 'rxjs';
import { TokenService } from '../services/token.service';

@Injectable()
export class TokenInterceptor implements HttpInterceptor {

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const loginToken = localStorage.getItem('jwt');

    if (loginToken) {
      request = request.clone({
        setHeaders: {
          'Authorization': `Bearer ${loginToken}`
        }
      });
    }

    return next.handle(request);
  }
}
